
import { FetchingActionType, PersistItemsActionType } from 'features/Persist/actionTypes';
import { PersistItemsReducer } from 'features/Persist/reducerTypes';
import { UrgencyResponse } from 'services/tenantManagementService';
import { TICKET_URGENCY_SET, TICKET_URGENCY_FETCHING } from './action';

export const ticketUrgencyReducer = (state = new PersistItemsReducer<UrgencyResponse>(), action: PersistItemsActionType<UrgencyResponse> | FetchingActionType): PersistItemsReducer<UrgencyResponse> => {
	switch (action.type) {
		case TICKET_URGENCY_FETCHING:
			const { fetching } = action as FetchingActionType;

			return {
				...state,
				fetching
			}
		case TICKET_URGENCY_SET:
			const { items } = action as PersistItemsActionType<UrgencyResponse>;

			const itemsMap: { [id: number]: UrgencyResponse } = items.reduce(
                (map: { [id: number]: UrgencyResponse }, item) => {
					map[item.id] = item;
					return map;
				},
                {}
			);

			return {
				items,
				itemsMap,
				fetching: false,
				isInitialized: true
			}
		default:
			return state;
	}
};
